// ExistingLoansPage.jsx
import React from "react";
import { Breadcrumbs, Grid, Typography } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
//style
import { NavLink, Link } from "react-router-dom";
import "./CreditScore.css";
import "../../styles/JourneyRightSection/responsive.css";
import { useLocation } from "react-router-dom";
import leadDetails from "./LeadDetailsPage.module.css";
import Loader from "../../../src/components/Loader/Loader";
//Images
import CRIF from "./images/CRIF.svg";
import TransUnion from "./images/TransUnion.svg";
import experian from "./images/experian.svg";
import Equifax from "./images/Equifax.svg";

//micro component
import CreditScoreArc from "../BuroRecords/creditScoreArc";
import newStyleCred from "./ScoreDetailsPage.style";
import { useCookies } from "react-cookie";
import { getCookie } from "../../utils/common";
import * as urls from "../../urls"; ///utils/urls
import axios from "axios";
import { useState, useEffect, useContext } from "react";
import ScoreCard from "./scoreCard";

import CustomerContext from "../../context/CustomerContext";

const AccountsDetails = (props) => {
  let domain = window.location.host.split(".")[0];
  if (window.location.host.includes("localhost")) {
    domain = "yoindi";
  }

  // * Context to store customer details
  const { customerDetails } = useContext(CustomerContext);

  // * Cookies
  const [cookies, setCookie] = useCookies(["user"]);

  const contact_id = getCookie("contactID");
  const access_token = getCookie("tokenForCustomers");
  const activeSlide = getCookie("lastSlide");

  const location = useLocation();
  const newCreditStyle = newStyleCred();

  const [paymentPercentage, setPaymentPercentage] = useState(0);
  console.log("paymentPercentage", paymentPercentage);
  const [cardUtilizationPer, setCardUtilizationPer] = useState(0);
  console.log("cardUtilizationPer", cardUtilizationPer);
  const [paymentHistoryArr, setPaymentHistoryArr] = useState([]);
  console.log("paymentHistoryArr", paymentHistoryArr);
  const [totalAge, setTotalAge] = useState("");
  console.log("totalAge", totalAge);
  const [totalOverdueAmt, setTotalOverdueAmt] = useState(false);
  console.log("totalOverdueAmt", totalOverdueAmt);
  const [creditScore, setCreditScore] = useState(null);
  console.log("creditScore", creditScore);
  const [isLoading, setIsLoading] = useState(false);

  const [arrListNew, setArrList] = useState([]);
  const [duplicateList, setDuplicateList] = useState([]);

  const [selectedFilter, setSelectedFilter] = useState("");

  const headersCommonNews = {
    domain_name: domain,

    Authorization: `Bearer ${access_token || ""}`,
    "Content-Type": "application/json",
  };

  let bodyData = {
    contact_id: contact_id,
  };

  function monthDiff(dateFrom, dateTo) {
    return (
      dateTo.getMonth() -
      dateFrom.getMonth() +
      12 * (dateTo.getFullYear() - dateFrom.getFullYear())
    );
  }

  function diff_year_month_day(dt1, dt2) {
    var time = (dt2.getTime() - dt1.getTime()) / 1000;
    var year = Math.abs(Math.round(time / (60 * 60 * 24) / 365.25));
    var month = Math.abs(Math.round(time / (60 * 60 * 24 * 7 * 4)));
    // var days = Math.abs(Math.round(time / (3600 * 24)));
    let totMonth = year * 12;
    let reqMonth = 0;
    if (totMonth < month) {
      reqMonth = month - totMonth;
    }
    if (year || reqMonth) {
      return year + "y " + reqMonth + "m";
    } else {
      return 0;
    }
  }

  function daysDiff(dt1, dt2) {
    // calculate the time difference of two dates JavaScript
    var diffTime = dt2.getTime() - dt1.getTime();

    // calculate the number of days between two dates javascript
    var daysDiff = diffTime / (1000 * 3600 * 24);

    return daysDiff;
  }

  const handleLoanFilter = (filteredLoan) => {
    // console.log("arrListNew=>", arrListNew);
    if (selectedFilter === filteredLoan) {
      setSelectedFilter("");
      setArrList(duplicateList);
    } else {
      setSelectedFilter(filteredLoan);
      let filteredList = duplicateList.filter(
        (data) => data.accountType === filteredLoan
      );

      if (JSON.stringify(filteredList) !== JSON.stringify(arrListNew)) {
        // console.log("filtered list=>", filteredList);
        setArrList(filteredList);
      }
    }
  };

  useEffect(() => {
    setIsLoading(true);
    var config7 = {
      method: "post",
      url: `${process.env.REACT_APP_API_BASE_URL}${urls.CREDIT_DETAILS_DB}`,
      headers: headersCommonNews,
      data: bodyData,
    };
    axios(config7)
      .then(function (response) {
        console.log("response DBs=>", response?.data?.data);
        setIsLoading(false);
        console.log(
          "response=>",
          response?.data?.data?.crfi_data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.[
            "SCORE-VALUE"
          ]
        );
        setCreditScore(
          response?.data?.data?.crfi_data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.[
            "SCORE-VALUE"
          ]
        );
        let list = response?.data?.data?.crfi_data?.["B2C-REPORT"];

        let arrList = [];
        let totalpaymentMonthCount = 0;
        let allTotalMonths = 0;
        console.log("allTotalMonths", allTotalMonths);
        let totalBalance = 0;
        let totalCredit = 0;
        let totalOverdueAmount = 0;
        let disburseDate = [];
        let historyArr = [];
        console.log("inside list=>", list);
        let arrAc = [];
        let arrCl = [];
        console.log("if1234", list?.RESPONSES);
        list?.RESPONSES?.map((d) => {
          console.log("if12345", d?.RESPONSE);
          if (d?.RESPONSE?.["LOAN-DETAILS"]?.["ACCOUNT-STATUS"] === "Active") {
            arrAc.push(d);
            console.log("if");
          } else {
            arrCl.push(d);
            console.log("else");
          }
        });
        let newlist = [...arrAc, ...arrCl];
        console.log("newList=>", newlist);
        newlist.map((data) => {
          let loanDetails = data?.RESPONSE?.["LOAN-DETAILS"];
          console.log("loanDetails", loanDetails);
          console.log("inside list=>", data);
          // if (loanDetails?.["ACCT-TYPE"] === "Credit Card") {
          let dateString = loanDetails?.["DISBURSED-DT"];
          let [day, month, year] = dateString.split("-");
          const dateObj = new Date(+year, +month - 1, +day);
          disburseDate.push(dateObj);

          // if (loanDetails?.["ACCOUNT-STATUS"] === "Active") {
          let months = monthDiff(dateObj, new Date());
          // } else {
          //   months = monthDiff(dateObj, d);
          // }
          console.log("dateCheck=>", months);
          var years = loanDetails?.["DISBURSED-DT"]
            ? new Date(
                new Date() - new Date(loanDetails?.["DISBURSED-DT"])
              ).getFullYear() - 1970
            : 0;
          let ageAcount = diff_year_month_day(new Date(), dateObj);
          let dateLast = loanDetails?.["LAST-PAYMENT-DATE"]
            ? loanDetails?.["LAST-PAYMENT-DATE"]
            : "";
          let days = "";
          if (dateLast) {
            let [dayl, monthl, yearl] = dateLast?.split("-");
            const dateObjLast = new Date(+yearl, +monthl - 1, +dayl);
            let daysLastPay = loanDetails?.["LAST-PAYMENT-DATE"]
              ? daysDiff(dateObjLast, new Date())
              : 0;
            days = daysLastPay;
          }
          console.log("Days=>", days);
          let newArray = loanDetails?.["COMBINED-PAYMENT-HISTORY"]
            .split(",")
            .map((data, index) => {
              if (index === 0) {
                return data;
              }
              if (
                index !==
                loanDetails?.["COMBINED-PAYMENT-HISTORY"].length - 1
              ) {
                return data.split("|")[1];
              }
            });
          let fullPaymentMonthCount = 0;
          let lateDaysCountArr = loanDetails?.["COMBINED-PAYMENT-HISTORY"]
            .split("|")
            .map((data) => {
              console.log("data=>", newArray);

              if (data.split(",")[1]) {
                let obj = {};
                if (!parseInt(data.split(",")[1].slice(0, 3))) {
                  fullPaymentMonthCount = fullPaymentMonthCount + 1;
                  allTotalMonths = allTotalMonths + 1;
                  obj = {
                    data: "",
                    month: data.split(",")[0].split(":")[0],
                    year: data.split(",")[0].split(":")[1],
                  };
                } else {
                  obj = {
                    data: parseInt(data.split(",")[1].slice(0, 3)),
                    month: data.split(",")[0].split(":")[0],
                    year: data.split(",")[0].split(":")[1],
                  };
                }
                return obj;
              }
            });

          // let countArr = [];

          let reqArrya = [];
          newArray.map((data) => {
            if (data) {
              let obj = {
                mon: data.split(":")[0],
                year: data.split(":")[1],
              };
              reqArrya.push(obj);
            }
          });
          const groupByCategory = reqArrya.reduce((group, product) => {
            const { year } = product;
            group[year] = group[year] ?? [];
            group[year].push(product.mon);
            return group;
          }, {});
          let missed = days < 30 ? 0 : days / 30 > 6 ? 6 : days / 30;
          let missedInLast6Month = Math.floor(missed);
          let NewdateLast = loanDetails?.["LAST-PAYMENT-DATE"]
            ? loanDetails?.["LAST-PAYMENT-DATE"]
            : "";
          let latestDate = "";
          if (NewdateLast) {
            let [day1, monthl, yearl] = NewdateLast?.split("-");
            let newDate = new Date(+yearl, +monthl - 1, +day1);
            let d = newDate.getDate();

            const m = newDate.toLocaleString("default", { month: "short" });
            let y = newDate.getFullYear();
            let dateN = d + " " + m + ", " + y;

            latestDate = dateN;
          }
          let disDate = loanDetails?.["DISBURSED-DT"]
            ? loanDetails?.["DISBURSED-DT"]
            : "";
          let lastDisDate = "";
          if (disDate) {
            let [day1, monthl, yearl] = disDate?.split("-");
            let newDate = new Date(+yearl, +monthl - 1, +day1);
            let d = newDate.getDate();

            const m = newDate.toLocaleString("default", { month: "short" });
            let y = newDate.getFullYear();
            let dateN = d + " " + m + ", " + y;

            lastDisDate = dateN;
          }
          console.log("newArray=>", lateDaysCountArr, groupByCategory);
          let obj = {
            limit: loanDetails?.["CREDIT-LIMIT"],
            status: loanDetails?.["ACCOUNT-STATUS"],
            lastUpdated: latestDate,

            lenderName: loanDetails?.["CREDIT-GUARANTOR"],
            lastPayDay: days,
            last6month: missedInLast6Month,
            reportingDate:
              newArray[0].split(":")[0] + " ," + newArray[0].split(":")[1],
            disbursedAmt: loanDetails?.["DISBURSED-AMT"],
            disbursedDate: lastDisDate,
            accountNumber: loanDetails?.["ACCT-NUMBER"],
            holderType: loanDetails?.["OWNERSHIP-IND"],
            outstanding: loanDetails?.["CURRENT-BAL"],
            accountType: loanDetails?.["ACCT-TYPE"],
            paymentHistory: loanDetails?.["COMBINED-PAYMENT-HISTORY"],
            paymentMonthCount: loanDetails?.[
              "COMBINED-PAYMENT-HISTORY"
            ]?.replace(/[^|]/g, "").length,
            totalMonths: fullPaymentMonthCount,
            currentBalance: loanDetails?.["CURRENT-BAL"],
            ageAccount: ageAcount,
            historyArray: loanDetails?.["COMBINED-PAYMENT-HISTORY"].split(","),
            paymentHistoryDate: groupByCategory,
            duesDaysCountArray: lateDaysCountArr,
          };
          let limitNew = loanDetails?.["CREDIT-LIMIT"]
            ? parseInt(loanDetails?.["CREDIT-LIMIT"].replace(/,/g, ""))
            : 0;
          console.log("lomitNew=>", limitNew, loanDetails?.["CREDIT-LIMIT"]);
          totalBalance =
            totalBalance +
            parseInt(loanDetails?.["CURRENT-BAL"].replace(/,/g, ""));
          if (loanDetails?.["OVERDUE-AMT"]) {
            totalOverdueAmount =
              totalOverdueAmount +
              parseInt(loanDetails?.["OVERDUE-AMT"].replace(/,/g, ""));
            console.log("totalOverdueAmount", totalOverdueAmount);
          }
          totalCredit = totalCredit + limitNew;
          totalpaymentMonthCount =
            totalpaymentMonthCount +
            loanDetails?.["COMBINED-PAYMENT-HISTORY"]?.replace(/[^|]/g, "")
              .length;

          console.log("newArr=>", groupByCategory, obj);
          historyArr.push(groupByCategory);
          arrList.push(obj);
          // }
        });
        const minDate = new Date(Math.min.apply(null, disburseDate));
        let totalAgeCount = diff_year_month_day(new Date(), minDate);
        setTotalAge(totalAgeCount);
        console.log("totalAgeCount", totalAgeCount);
        console.log("historyArr=>", historyArr);
        setPaymentHistoryArr(historyArr);
        let paymentPercentage = (allTotalMonths / totalpaymentMonthCount) * 100;
        console.log(
          "TotalBal=>",
          allTotalMonths,
          paymentPercentage,
          totalBalance,
          totalCredit,

          totalBalance / totalCredit
        );
        let cardUtilizationPer = (totalBalance / totalCredit) * 100;
        console.log(
          "data Uti=>",
          totalBalance,
          totalCredit,
          cardUtilizationPer
        );
        setPaymentPercentage(paymentPercentage);
        setCardUtilizationPer(cardUtilizationPer);
        setTotalOverdueAmt(
          Intl.NumberFormat("en-IN").format(totalOverdueAmount)
        );
        console.log();
        console.log("ReqList=>", totalOverdueAmount);
        setArrList(arrList);
        setDuplicateList(arrList);
      })
      .catch((error) => {});
  }, []);

  return (
    // <div>
    
    <div>
       
      {
      isLoading ? (
              <Box sx={{ display: 'flex',justifyContent: "space-around", }}>
              <CircularProgress />
            </Box>
            ) : 
      <div className="wrapperCredit">
        <div className="breadcrumbs">
          <Breadcrumbs aria-label="breadcrumb">
            <Link to="/customers/home/dashboard">HOME</Link>
            <Link to="/customers/home/dashboard">CIBIL</Link>
            <Link to="">ACCOUNT DETAILS</Link>
          </Breadcrumbs>
        </div>
        <Grid>
          <section
            className="section-scorefactors"
            style={{
              marginTop: "20px",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              // fontFamily: "Red Hat Display",
            }}
          >
            <div className="heading-block">
              <div
                className="section-heading"
                 style={{ fontSize: "18px", fontWeight: 600,marginBottom:10 }}
              >
                Credit Score Factors
              </div>
              {/* <p style={{ fontWeight: 500, color: "gray", fontSize: "14px" }}>
                Factors that effects your score
              </p> */}
            </div>
            <>
              <div className="row factors-row">
                <div className="rp-coltype-item col-3">
                  <div
                    className="item-col item-keyval-col"
                    style={{ borderRadius: "10px" }}
                  >
                    <span className={leadDetails.text_style_factor}>
                      On-Time Payments
                    </span>
                    {console.log("paymentPercentage :", paymentPercentage)}
                    <label>
                      {paymentPercentage ? Math.round(paymentPercentage) : 0}%
                    </label>
                  </div>
                </div>
                <div className="rp-coltype-item col-3">
                  <div
                    className="item-col item-keyval-col"
                    style={{ borderRadius: "10px" }}
                  >
                    <span className={leadDetails.text_style_factor}>
                      Credit Utilization
                    </span>
                    <label>
                      {/* 32% */}
                      {cardUtilizationPer > 100
                        ? "100%"
                        : cardUtilizationPer
                        ? Math.round(cardUtilizationPer) + "%"
                        : 0}
                      {/* % */}
                      {/* {cardUtilizationPer ? Math.round(cardUtilizationPer) : 0}% */}
                      {cardUtilizationPer && cardUtilizationPer < 30 ? (
                        <small className="alert alert-danger">
                          Need Improvement
                        </small>
                      ) : (
                        ""
                      )}
                      {/* <small className="alert alert-danger">Need Improvement</small> */}
                    </label>
                  </div>
                </div>
                <div className="rp-coltype-item col-3">
                  <div
                    className="item-col item-keyval-col"
                    style={{ borderRadius: "10px" }}
                  >
                    <span className={leadDetails.text_style_factor}>
                      Overdue Amount
                    </span>
                    <label>
                      {totalOverdueAmt ? totalOverdueAmt : "0"}
                      {/* 25000 */}
                    </label>
                  </div>
                </div>
                <div className="rp-coltype-item col-3">
                  <div
                    className="item-col item-keyval-col"
                    style={{ borderRadius: "10px" }}
                  >
                    <span className={leadDetails.text_style_factor}>
                      Credit Age
                    </span>
                    <label>
                      {totalAge ? totalAge : "0"}
                      {/* 4y 4m */}
                    </label>
                  </div>
                </div>
              </div>
            </>
          </section>
        </Grid>

        <section
          
          className={leadDetails.section_youraccounts}
          // style={{ marginTop: "30px" }}
        >
        <div className="section-scorefactors" 
         style={{
          marginTop: "20px",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
        }}
         >  
          <div className="heading-block " style={{marginBottom: 10}}>
            <h2 className="section_heading">Account Details</h2>
            {/* <p className="Factor">Factors that effects your score</p> */}
          </div>

          {/* <Grid container spacing={2} > */}
            {/* <Grid item xs={6} sm={6} md={4} lg={3}> */}
            <div className="scroll-Account" style={{marginRight: 5}}>
              {/* <div style={{marginRight:"1px"}}> */}
              <span
                className={`${newCreditStyle.filterCards} ${
                  selectedFilter === "Personal Loan"
                    ? newCreditStyle.selectedCard
                    : ""
                }`}
                onClick={() => handleLoanFilter("Personal Loan")}
              >
                Personal Loan
              </span>
            {/* </Grid> */}
            {/* <Grid item xs={6} sm={6} md={4} lg={3}> */}
              <span
                style={{marginLeft: 10}}
                className={`${newCreditStyle.filterCards} ${
                  selectedFilter === "Credit Card"
                    ? newCreditStyle.selectedCard
                    : ""
                }`}
                onClick={() => handleLoanFilter("Credit Card")}
              >
                Credit Card
              </span>
            {/* </Grid> */}
            {/* <Grid item xs={6} sm={6} md={4} lg={3}> */}
              <span
                style={{marginLeft: 10}}
                className={`${newCreditStyle.filterCards} ${
                  selectedFilter === "Consumer Loan"
                    ? newCreditStyle.selectedCard
                    : ""
                }`}
                onClick={() => handleLoanFilter("Consumer Loan")}
              >
                Consumer Loan
              </span>
            {/* </Grid> */}

            {/* <Grid item xs={6} sm={6} md={4} lg={3}> */}
              <span
                style={{marginLeft: 10}}
                className={`${newCreditStyle.filterCards} ${
                  selectedFilter === "Gold Loan"
                    ? newCreditStyle.selectedCard
                    : ""
                }`}
                onClick={() => handleLoanFilter("Gold Loan")}
              >
                Gold Loan
              </span>
            {/* </Grid> */}
            {/* <Grid item xs={6} sm={6} md={4} lg={3}> */}
              <span
                style={{marginLeft: 10}}
                className={`${newCreditStyle.filterCards} ${
                  selectedFilter === "Education Loan"
                    ? newCreditStyle.selectedCard
                    : ""
                }`}
                onClick={() => handleLoanFilter("Education Loan")}
              >
                {" "}
                Education Loan
              </span>
            {/* </Grid> */}
            {/* <Grid item xs={6} sm={6} md={4} lg={3}> */}
              <span
                style={{marginLeft: 10}}
                className={`${newCreditStyle.filterCards} ${
                  selectedFilter === "Auto Loan(Personal)"
                    ? newCreditStyle.selectedCard
                    : ""
                }`}
                onClick={() => handleLoanFilter("Auto Loan(Personal)")}
              >
                {" "}
                Auto Loan
              </span>
            {/* </Grid> */}
            {/* <Grid item xs={6} sm={6} md={4} lg={3}> */}
              <span
                style={{marginLeft: 10 }}
                className={`${newCreditStyle.filterCards} ${
                  selectedFilter === "Other" ? newCreditStyle.selectedCard : ""
                }`}
                onClick={() => handleLoanFilter("Other")}
              >
                Other
              </span>
              </div>
            {/* </Grid> */}
          {/* </Grid> */}
          {/* </div> */}
          </div>
          <div
            // style={{  }}
            // sm={12}

            className={isLoading && newCreditStyle.contentCenter}
          ><Grid container spacing={2} style={{marginTop: "2px"}}>
            {isLoading ? (
              <Loader />
            ) : arrListNew.length > 0 ? (
              arrListNew.map((data, index) => {
                return <ScoreCard key={index} data={data} />;
              })
            ) : (
              <h1 style={{ fontWeight: 500, color: "gray", fontSize: "20px", display: "flex" , flexDirection: "column", textAlign: "center" , width: "100%", paddingTop:"10px" }}>
                You don't have any type of loan
              </h1>
            )}
            </Grid>
          </div>
        </section>
      </div>
}
    </div>
  );
};

export default AccountsDetails;
